export default __webpack_public_path__ + "static/media/logo-linkedin.31ec2ffe.svg";